import { extend } from 'vee-validate'
// eslint-disable-next-line camelcase
import { email, max, required, required_if } from 'vee-validate/dist/rules'

extend('email', email)
extend('max', max)
extend('required_if', {
  // eslint-disable-next-line camelcase
  ...required_if,
  message: 'This field is required.'
})
extend('required', {
  ...required,
  message: 'This field is required.'
})
